import {createBrowserRouter} from 'react-router-dom';

import Root from '../pages/root/Root';
import Main from '../pages/main';
import ErrorPage from '../pages/error/ErrorPage';
import ServiceRequests from '../pages/service-requests';
import NewServiceRequest from '../pages/service-requests/new';
import ServiceRequest from '../pages/service-requests/[id]';
import AssignServiceRequests from '../pages/service-requests/assign';
import Contracts from '../pages/contracts';
import Contract from '../pages/contracts/[id]';
import AddContract from '../pages/contracts/add-contract';
import Users from '../pages/users';
import Clients from '../pages/clients';
import Company from '../pages/clients/[id]';
import AddCompany from '../pages/clients/add-company/AddCompany';
import Reports from '../pages/reports';
import Report from '../pages/reports/[id]';
import ReportExecuted from '../pages/reports/executed';
import ReportUniversal from '../pages/reports/universal';
import ReportForma from '../pages/reports/forma';
import ReportDelay from '../pages/reports/delay';
import ReportMasterCounter from '../pages/reports/masterCounter';
import Settings from '../pages/settings';
import ImportDevices from '../pages/settings/importDevices';
import Dictionaries from '../pages/dictionaries/';
import DeviceTypes from '../pages/dictionaries/device-types';
import DeviceModels from '../pages/dictionaries/device-models';
import Devices from '../pages/dictionaries/devices';
import DeviceTypeCode from '../pages/dictionaries/[code]';
import TaskLocations from '../pages/dictionaries/task-locations';
import TaskLocationCode from '../pages/dictionaries/task-locations/[code]';
import ReasonRejections from '../pages/dictionaries/reason-rejections';
import ReasonRejectionCode from '../pages/dictionaries/reason-rejections/[code]';
import Login from '../pages/login';
import DemoRegistrationPage from '../pages/demo-registration';

import PrivateRoute from '../providers/PrivateRoute';
import GuestRoute from '../providers/GuestRoute';
import {ReportPreview} from '../components/Reports/report/ReportPreview';
import {ModalPageProvider} from '../providers/ModalPageProvider';
import {ServiceRequestsLayout} from '../pages/service-requests/layout';
import {ContractsLayout} from '../pages/contracts/layout';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <PrivateRoute>
        <Root />
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        path: '/',
        element: <ModalPageProvider />,
        children: [
          {
            index: true,
            element: <Main />,
          },
          {
            path: 'serviceRequests',
            element: <ServiceRequestsLayout />,
            children: [
              {
                index: true,
                element: <ServiceRequests />,
              },
              {
                path: 'new',
                element: <NewServiceRequest />,
              },
              {
                path: 'assign',
                element: <AssignServiceRequests />,
              },
              {
                path: ':id',
                element: <ServiceRequest />,
              },
            ],
          },
          {
            path: 'contracts',
            element: <ContractsLayout />,
            children: [
              {
                index: true,
                element: <Contracts />,
              },
              {
                path: 'addContract',
                element: <AddContract />,
              },
              {
                path: ':id',
                element: <Contract />,
              },
            ],
          },
          {
            path: 'users',
            element: <Users />,
          },
          {
            path: 'dictionaries',
            element: <Dictionaries />,
          },
          {
            path: 'dictionaries/deviceTypes',
            element: <DeviceTypes />,
          },
          {
            path: 'dictionaries/deviceTypes/:id',
            element: <DeviceTypeCode />,
          },
          {
            path: 'dictionaries/taskLocations',
            element: <TaskLocations />,
          },
          {
            path: 'dictionaries/taskLocations/:id',
            element: <TaskLocationCode />,
          },
          {
            path: 'dictionaries/reasonRejections',
            element: <ReasonRejections />,
          },
          {
            path: 'dictionaries/reasonRejections/:id',
            element: <ReasonRejectionCode />,
          },
          {
            path: 'dictionaries/deviceModels',
            element: <DeviceModels />,
          },
          {
            path: 'dictionaries/devices',
            element: <Devices />,
          },
          {
            path: 'customers',
            element: <Clients />,
          },
          {
            path: 'customers/:id',
            element: <Company />,
          },
          {
            path: 'customers/addCompany',
            element: <AddCompany />,
          },
          {
            path: 'reports',
            element: <Reports />,
          },
          {
            path: 'reports/:id',
            element: <Report />,
          },
          {
            path: 'reports/executed',
            element: <ReportExecuted />,
          },
          {
            path: 'reports/universal',
            element: <ReportUniversal />,
          },
          {
            path: 'reports/forma',
            element: <ReportForma />,
          },
          {
            path: 'reports/delay',
            element: <ReportDelay />,
          },
          {
            path: 'reports/masterCounter',
            element: <ReportMasterCounter />,
          },
          {
            path: 'settings',
            element: <Settings />,
          },
          {
            path: 'settings/importDevices',
            element: <ImportDevices />,
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/demo-registration',
    element: (
      <GuestRoute>
        <DemoRegistrationPage />
      </GuestRoute>
    ),
  },
  {
    path: 'reports/executed/preview/:id',
    element: <ReportPreview />,
    errorElement: <ErrorPage />,
  },
  {
    path: 'reports/universal/preview/:id',
    element: <ReportPreview />,
    errorElement: <ErrorPage />,
  },
]);
